export const RQ_MODULE_PREFIX = '_RQ_module_name';

export const RQ_USER = `${RQ_MODULE_PREFIX}_user`;
